export enum AUTH_ERROR_TYPE {
  TOKEN_EXPIRED = 'Access token has expired',
}

export const AUTH_ERROR_MESSAGE = {
  TOKEN_EXPIRED: 'Your link has expired, please try again.',
  AUTHENTICATION_EXPIRED:
    'Your authentication has expired, please log in again',
};
